import { getImageBase64, getThemePic } from "@/views/home/slidePPT/use/methods";

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);
  const imgsrcList = await getImageBase64(node.title, 3);
  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "nR9HVsY6gP",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7aMOtHGQL_",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "K-x_oM9Zyl",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "k0FMpMDXzQ",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "8csSljinQS",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "T-015XvyVB",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "at7U2SFu4N",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "RYpwFKyEW5",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "jemaBgMb4C",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "p0E3mpoy98",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "d-CWgHTGfj",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lJU4o_dLp0",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hhTnNQZfQ1",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "taIUIhdxA5",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "LdWee_CMvX",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "IPcn5EbgvK",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SNMW0d64NV",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "aKbol-RLvb",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_K5AaXvK-d",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "PZw0FT8vlF",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "KXEMITEO_B",
        width: 370.8246391076115,
        height: 32.6875,
        left: 490.71489501312334,
        top: 255.64337270341207,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;">${node.children[1].title || "02"
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "bpW20SBmp1",
        width: 474.350967847769,
        height: 57.59375,
        left: 490.71489501312334,
        top: 293.23712270341207,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[1].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "vFwUCeKzU6",
        width: 370.8246391076115,
        height: 32.6875,
        left: 490.71489501312334,
        top: 391.1957841207349,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;">${node.children[2].title || "03"
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "jK5V3MwcEU",
        width: 474.350967847769,
        height: 57.59375,
        left: 490.71489501312334,
        top: 428.7895341207349,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[2].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "l372vCR0Ib",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: Microsoft Yahei;">${node.title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "rbSLdZ9QUM",
        width: 370.8246391076115,
        height: 32.6875,
        left: 490.71489501312334,
        top: 120.4201935695538,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 24.21875px;"><span style="font-family: Microsoft Yahei;">${node.children[0].title || "01"
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "_QIHH-Xfhi",
        width: 467.591125328084,
        height: 57.59375,
        left: 490.71489501312334,
        top: 158.01394356955382,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[0].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "image",
        id: "y-A2jd8VDd",
        src: imgsrcList[0],
        width: 374.26377952755905,
        height: 374.2638615485564,
        left: 71.27673884514435,
        top: 106.10515091863518,
        fixedRatio: true,
        rotate: 0,
        clip: {
          shape: "rhombus",
          range: [
            [0, 0],
            [100, 100],
          ],
        },
      },
    ],
    background: {
      type: "solid",
      color: "#fff",
    },
  };
};

export default nodule;
